<template>
  <div
    class="row q-gutter-sm"
    data-test-id="membership-type-chip"
  >
    <q-chip
      :icon-right="iconRight"
      :clickable="clickable"
      square
      :label="user.membershipType && user.membershipType.name"
      data-test-id="membership-type-chip-button"
      @click.stop="showTypeSelector"
    >
      <q-tooltip v-if="clickable">
        {{ $t('membership.changeTypeTooltip') }}
      </q-tooltip>
    </q-chip>
    <membership-type-selector
      ref="membershipTypeSelector"
      @select-membership-type="membershipType => $emit('select-membership-type', membershipType)"
    />
  </div>
</template>

<script>

import MembershipTypeSelector from 'src/modules/register/membership/MembershipTypeSelector'

export default {
  name: 'MembershipTypeChip',
  components: {
    MembershipTypeSelector
  },
  props: {
    user: {
      type: Object,
      required: true
    },
    clickable: {
      type: Boolean,
      required: false,
      default: true
    },
    enableSetForAll: {
      type: Boolean,
      required: false,
      default: true
    },
    iconRight: {
      type: String,
      required: false,
      default: undefined
    }
  },
  emits: ['select-membership-type'],
  methods: {
    showTypeSelector () {
      this.$refs.membershipTypeSelector.show(
        this.user,
        this.user.id === this.user.membership.initialMember.id,
        this.enableSetForAll && this.user.id === this.user.membership.members.data[0].id
      )
    }
  }
}

</script>
